import { getSucursal } from "./helpers";

export const apiUrl = (path, useSucursal = true) => {
    const sucursal = useSucursal ? "s/" + getSucursal() + "/" : "";
    return `https://api.sae.com.do/api/v1/${sucursal}${path}`;
    //return `https://apinext.sae.com.do/api/v1/${sucursal}${path}`;
    //return `http://localhost:8000/api/v1/${sucursal}${path}`;
    //return `https://apiqa.sae.com.do/api/v1/${sucursal}${path}`;
}
